import { __rest } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1$1 from '@angular/forms';
import { Validators } from '@angular/forms';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import * as i6 from 'dirty-check-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as errorUtils from 'error-message-utility';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import moment from 'moment';
import { pluck, take } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i4 from 'ngx-toastr';
import * as i5 from 'step-status-update-payload-service';
import * as i7 from 'cache-country-list';
import * as i8 from 'reference-library';
import * as i9 from 'primeng/dynamicdialog';
import * as i10 from 'app-services-library';

class APIJobDescription {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getStates(countryCode) {
        return this.httpClient.get(`/countries/states?countryCode=${countryCode}`).pipe(map((response) => {
            if (response.status) {
                return response.data;
            }
        }));
    }
    ongetSOCCode(soccode) {
        return this.httpClient.get(`/soc/${soccode}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    getJobDescription(visatype, caseType, caseId, isForeignCompany) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/jobDescription?isThisPastJob=${isForeignCompany}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    postJobDescription(payload, visatype, caseType, caseId) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/jobDescription`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    postPositionJobDescription(payload, visatype, caseType, caseId) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/positionDetails`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    postWorkJobDescription(payload, visatype, caseType, caseId) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/identifyWorkLocation`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    deleteWorkLocation(visatype, caseType, caseId, workLocationId) {
        return this.httpClient.delete(`/${visatype}/${caseType}/${caseId}/workLocation/${workLocationId}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getIOSMapping(visatype, caseType, caseId, positionId, dutyId) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/position/${positionId}/duty/${dutyId}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getJobRolesDuties(companyId, jobRoleId) {
        // return this.httpClient.get(`/${visatype}/company/${companyId}/position/${jobTitle}`).pipe(
        //   map((response: ImagilityBaseResponse) => {
        //     if (response.status === 200) {
        //       return response;
        //     }
        //   })
        // );
        return this.httpClient.get(`/company/${companyId}/masterData/jobRole/${jobRoleId}`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    postJobRole(companyId, caseId, jobRole) {
        const payloadObj = {
            jobRole
        };
        return this.httpClient.post(`/petitionBuilder/petition/${caseId}/company/${companyId}/jobRole/${jobRole}`, payloadObj).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getJobRoles(companyId) {
        return this.httpClient.get(`/company/${companyId}/MASTERDATA/JOBROLE`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    saveJobRole(companyId, categoryId, paylod) {
        return this.httpClient.post(`/company/${companyId}/${categoryId}/masterData/jobRole`, paylod).pipe(map((response) => {
            return response;
        }));
    }
}
APIJobDescription.ɵfac = function APIJobDescription_Factory(t) { return new (t || APIJobDescription)(i0.ɵɵinject(i1.HttpClient)); };
APIJobDescription.ɵprov = i0.ɵɵdefineInjectable({ token: APIJobDescription, factory: APIJobDescription.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIJobDescription, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

//import { ListJobDutiesService } from 'list-job-duties';
const deleteDialogConfigurations = {
    width: '30%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { 'z-index': '1001' }
};
class BaseJobDescriptionLibraryService {
    constructor(jobDescriptionBuilder, store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, cacheCountyService, referenceLibraryService, changeDetector, dialogService, customValidator, appServicesLibraryService) {
        this.jobDescriptionBuilder = jobDescriptionBuilder;
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.cacheCountyService = cacheCountyService;
        this.referenceLibraryService = referenceLibraryService;
        this.changeDetector = changeDetector;
        this.dialogService = dialogService;
        this.customValidator = customValidator;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.dutiesList = [];
        this.countryList = [];
        this.stateList = [];
        this.addressList = [];
        this.disabledControls = false;
    }
    loadInit() {
        this.jobDescriptionForm = this.jobDescriptionBuilder.group({
            id: [null],
            jobTitle: [null, Validators.required],
            duties: this.jobDescriptionBuilder.array([]),
            address: this.jobDescriptionBuilder.array([]),
            workLocationTypeCode: [null, Validators.required],
            wagesFrom: [null, [Validators.required, Validators.pattern(/^[1-9]\d*(\.\d+)?$/)]],
            wageTypeCode: [null, Validators.required],
            wagesPerYear: ['', [Validators.required, Validators.pattern(/^[1-9]\d*(\.\d+)?$/)]],
            wageTypeName: [null],
            thisFulltime: [false],
            workingHoursPerWeek: [null],
            startDate: [null, [Validators.required]],
            endDate: [null, [Validators.required]],
            workLocationId: [null],
            caseId: [],
            socCode1: [null],
            socCode2: [null],
            thisPastJob: [false],
            offerSignedByName: [null],
            educationRequired: [null],
            dotCode: [null],
            experienceRequired: [null],
            fieldOfStudy: [null],
            technicalSkills: [null],
            clientName: [null],
            clientEmail: [null],
            clientPhoneNo: [null],
            clientPhoneCountryCode: [this.isForeignCompany ? null : 'USA'],
            isMiddleVendor: [false],
            vendorList: this.jobDescriptionBuilder.array([]),
            jobDutyForceDelete: false,
            jobRole: [null],
            otherJobPosition: [null],
            selectedCategory: [null],
            selectedRaiobtn: [0],
            selectedEducationId: [null]
        }, {
            validator: this.customValidator.dateLessThan('startDate', 'endDate'),
        });
        this.getWageUnitType();
        this.updateFormControls();
        if (this.isForeignCompany) {
            this.cacheCountyService.getCountryWithoutUSA().subscribe(data => {
                if (data.length > 0) {
                    this.countryList = data;
                }
            });
        }
        else {
            this.getCountries();
        }
        // Get Specific step details by passing step code
        this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            this.getJobDescription();
            this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
            this.stepDetails = data;
            this.fileUploadConfigurations = Object.assign({}, {
                disableControls: this.disabledControls,
                isDocumentTypeRequired: true,
                isDocumentUploadRequired: true,
                isViewEnabled: true,
                isDownloadEnabled: true,
                isDeleteEnabled: true,
                getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/`,
                postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/fileCategory/`,
                deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                documentTypeDropdownCode: (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR',
                getDocTypeApiUrl: '/referenceLibrary/POSOFFRLTR'
                // getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/`,
                // postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/fileCategory/`,
                // deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                // documentTypeDropdownCode: this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'OFFLTR'
            });
            this.toggleControlsStatus();
        });
    }
    createVendorDetailsItem(obj) {
        const vendorItem = this.jobDescriptionBuilder.group({
            vendorName: [obj['vendorName'] ? obj['vendorName'] : ''],
            vendorLastName: [obj['vendorLastName'] ? obj['vendorLastName'] : ''],
            vendorFirstName: [obj['vendorFirstName'] ? obj['vendorFirstName'] : ''],
        });
        this.jobDescriptionForm.controls['vendorList'].push(vendorItem);
    }
    addVendor() {
        this.createVendorDetailsItem({});
    }
    deleteVendor(vendorIndex) {
        this.jobDescriptionForm.controls['vendorList'].removeAt(vendorIndex);
    }
    createAddressItem(obj) {
        const addressGroupItem = this.jobDescriptionBuilder.group({
            id: [obj.id],
            addressLine1: [obj && obj.addressLine1 ? obj.addressLine1 : '', Validators.required],
            addressLine2: [obj && obj.addressLine2 ? obj.addressLine2 : ''],
            addressLine2NoType: [null],
            addressTypeCode: 'WORK',
            beneficiaryId: [null],
            countryCode: [
                this.isForeignCompany ? obj.countryCode ? obj.countryCode : null : 'USA',
                this.isForeignCompany ? [Validators.required] : []
            ],
            countryName: [null],
            doorNo: [null],
            locality: [null],
            state: [null],
            stateProvinceCode: [obj && obj.stateProvinceCode ? obj.stateProvinceCode : null],
            stateProvinceName: [obj && obj.stateProvinceName ? obj.stateProvinceName : null],
            stateList: [],
            streetNo: [null],
            city: [obj && obj.city ? obj.city : '', [Validators.required, Validators.pattern('[a-zA-Z ]*')]],
            postCode: [obj && obj.postCode ? obj.postCode : '', Validators.required],
            clientName: [obj && obj.clientName ? obj.clientName : null],
            clientEmail: [obj && obj.clientEmail ? obj.clientEmail : null],
            clientPhoneNo: [obj && obj.clientPhoneNo ? obj.clientPhoneNo : null],
            clientPhoneCode: [this.isForeignCompany ? null : 'USA'],
            type: [null],
            familyId: [null],
            companyId: [null],
            employeeId: [null],
            immigrationId: [null],
            workLocationId: [obj.workLocationId ? obj.workLocationId : 0],
            sequenceNo: [0]
        });
        if (this.jobDescriptionForm.get('workLocationTypeCode').value === 'TPARTY' ||
            this.jobDescriptionForm.get('workLocationTypeCode').value === 'INHSECLT') {
            //addressGroupItem.get('clientName').setValidators(Validators.required);
            this.jobDescriptionForm.get('clientName').setValidators(Validators.required);
        }
        if (this.jobDescriptionForm.get('workLocationTypeCode').value === 'INHSE') {
            //addressGroupItem.get('clientName').clearValidators();
            this.jobDescriptionForm.get('clientName').clearValidators();
            this.jobDescriptionForm.get('clientName').updateValueAndValidity();
        }
        this.referenceLibraryService.getStatesFromStore(this.isForeignCompany ? obj.countryCode : 'USA')
            .pipe(take(1))
            .subscribe((states) => {
            if (states) {
                addressGroupItem.controls['stateList'].setValue(states);
                if (states && states.length > 0) {
                    addressGroupItem.get('stateProvinceName').clearValidators();
                    addressGroupItem.get('stateProvinceCode').setValidators(Validators.required);
                }
                else {
                    addressGroupItem.get('stateProvinceName').setValidators(Validators.required);
                    addressGroupItem.get('stateProvinceCode').clearValidators();
                }
                this.jobDescriptionForm.controls['address'].push(addressGroupItem);
            }
            else {
                this.referenceLibraryService.getStatesFromApi(this.isForeignCompany ? obj.countryCode : 'USA')
                    .pipe(take(1))
                    .subscribe((data) => {
                    addressGroupItem.controls['stateList'].setValue(data);
                    if (data && data.length > 0) {
                        addressGroupItem.get('stateProvinceName').clearValidators();
                        addressGroupItem.get('stateProvinceCode').setValidators(Validators.required);
                    }
                    else {
                        addressGroupItem.get('stateProvinceName').setValidators(Validators.required);
                        addressGroupItem.get('stateProvinceCode').clearValidators();
                    }
                    this.jobDescriptionForm.controls['address'].push(addressGroupItem);
                });
            }
        });
    }
    getStateList(countryCode = 'USA', item) {
        this.referenceLibraryService.getStatesFromStore(countryCode)
            .pipe(take(1))
            .subscribe((states) => {
            if (states) {
                item.controls['stateList'] = states;
            }
            else {
                this.referenceLibraryService.getStatesFromApi(countryCode)
                    .pipe(take(1))
                    .subscribe((data) => {
                    item.controls['stateList'] = data;
                });
            }
        });
    }
    handleCountryChange(countryCode, item, flag = false) {
        if (flag) {
            item.controls['stateProvinceCode'].setValue(null);
            item.controls['stateProvinceName'].setValue(null);
        }
        this.referenceLibraryService.getStatesFromStore(countryCode)
            .pipe(take(1))
            .subscribe((states) => {
            if (states) {
                item.controls['stateList'].setValue(states);
                if (states && states.length > 0) {
                    item.get('stateProvinceName').clearValidators();
                    item.get('stateProvinceCode').setValidators(Validators.required);
                }
                else {
                    item.get('stateProvinceName').setValidators(Validators.required);
                    item.get('stateProvinceCode').clearValidators();
                }
                this.changeDetector.markForCheck();
            }
            else {
                this.referenceLibraryService.getStatesFromApi(countryCode)
                    .pipe(take(1))
                    .subscribe((data) => {
                    item.controls['stateList'].setValue(data);
                    if (data && data.length > 0) {
                        item.get('stateProvinceName').clearValidators();
                        item.get('stateProvinceCode').setValidators(Validators.required);
                    }
                    else {
                        item.get('stateProvinceName').setValidators(Validators.required);
                        item.get('stateProvinceCode').clearValidators();
                    }
                    this.changeDetector.markForCheck();
                });
            }
        });
    }
    afterViewInit() {
        this.jobDescriptionForm.valueChanges
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(() => {
            if (this.jobDescriptionForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    getAddressFormArray() {
        return this.jobDescriptionForm.controls['address'].controls;
    }
    getVendorListFormArray() {
        return this.jobDescriptionForm.controls['vendorList'].controls;
    }
    buildDutyList(item) {
        const subJobDuty = [];
        if (item.subduty && item.subduty.length > 0) {
            item.subduty.forEach(element => {
                subJobDuty.push(this.buildSubDutyList(element));
            });
        }
        else if (item.subJobDuty && item.subJobDuty.length > 0) {
            item.subJobDuty.forEach(element => {
                subJobDuty.push(this.buildSubDutyList(element));
            });
        }
        return this.jobDescriptionBuilder.group({
            id: item.id,
            name: item.duty || item.name,
            subJobDuty: this.jobDescriptionBuilder.array(subJobDuty)
        });
    }
    buildSubDutyList(item) {
        return this.jobDescriptionBuilder.group({
            id: item.id,
            name: item.duty || item.name
        });
    }
    handleOnsaveJobRoleOrPopulateDuties(input) {
        const overlppingReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, Object.assign(Object.assign({}, deleteDialogConfigurations), { data: {
                deleteMessage: 'Do you wish to populate duties & sub duties? This will override any existing duties'
            } }));
        overlppingReconfirmDialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                if (this.jobDescriptionForm.value && this.jobDescriptionForm.value.id) {
                    this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.jobDescriptionForm.value.id, 0)
                        .pipe(take(1))
                        .subscribe((IOSMappingResponse) => {
                        if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
                            const deleteReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, Object.assign(Object.assign({}, deleteDialogConfigurations), { data: {
                                    deleteMessage: 'Job duties cannot be populated as Itinerary of Services mapping exists with the job duties. Do you want continue with the deletion of Itinerary of Services mapping?'
                                } }));
                            deleteReconfirmDialogRef.onClose
                                .pipe(takeUntil(this.observableSubscription$))
                                .subscribe((deleteReconfirmResponse) => {
                                if (deleteReconfirmResponse) {
                                    this.jobDescriptionForm.controls['jobDutyForceDelete'].setValue(true);
                                    this.populateJobDuties(input);
                                }
                            });
                        }
                        else {
                            this.populateJobDuties(input);
                        }
                    });
                }
                else {
                    // if there is no position id exists. no need to check ios mapping exists
                    this.populateJobDuties(input);
                }
            }
        });
    }
    populateJobDuties(input) {
        this.jobDescriptionForm.controls['duties'].clear();
        this.store.dispatch(new MarkDirtyFormAction({
            dirty: true
        }));
        this.apiService.getJobRolesDuties(this.inputData.companyId, input.selectedJobPositionId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.jobDuty && response.jobDuty.length > 0) {
                response.jobDuty.forEach(element => {
                    element['id'] = null;
                    if (element.subduty && element.subduty.length > 0) {
                        element.subduty.forEach(subJobDuty => {
                            subJobDuty['id'] = null;
                        });
                    }
                    this.jobDescriptionForm.controls['duties'].push(this.buildDutyList(element));
                });
            }
        });
    }
    handleAddUpdateDuty({ type, data, dutyIndex }) {
        if (type === 'ADD') {
            // If type is ADD then append the job duties to exisiting one
            this.jobDescriptionForm.controls['duties'].push(this.buildDutyList(data));
            this.store.dispatch(new MarkDirtyFormAction({
                dirty: true
            }));
        }
        if (type === 'UPDATE') {
            // If type is UPDATE then update the job duties
            this.jobDescriptionForm.controls['duties'].setControl(dutyIndex, this.buildDutyList(data));
            this.store.dispatch(new MarkDirtyFormAction({
                dirty: true
            }));
        }
    }
    getJobDescription() {
        this.apiService.getJobDescription(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.isForeignCompany)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a, _b;
            if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                this.loadFormValues(response.data);
                this.inputData.jsonInput = { jobCategory: (_a = response.data) === null || _a === void 0 ? void 0 : _a.jobCategory, jobRole: (_b = response.data) === null || _b === void 0 ? void 0 : _b.jobRole };
                // this.apiService.getJobRoles(this.inputData.companyId).pipe(takeUntil(this.observableSubscription$))
                //   .subscribe((responseJobRoles: ImagilityBaseResponse) => {
                //     if (responseJobRoles && responseJobRoles.data && responseJobRoles.data.length > 0 &&
                //       responseJobRoles.data.find(x => x.jobTitle === response.data['jobRole'])) {
                //       // predefined job role is selected do nothing
                //       response.data['otherJobPosition'] = '';
                //     }
                //     else {
                //       // Other option is selected & set the other job position manually
                //       response.data['otherJobPosition'] = response.data['jobRole'];
                //       response.data['jobRole'] = 'Other';
                //     }
                //     this.loadFormValues(response.data);
                //   });
            }
            else {
                // is there is no position details
                this.jobDescriptionForm.reset();
                this.jobDescriptionForm.patchValue({
                    selectedRaiobtn: 0,
                    jobRole: null
                });
                this.jobDescriptionForm.markAsPristine();
                this.jobDescriptionForm.markAsUntouched();
                this.loadAddress([]);
                this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
            }
        });
    }
    handleWorkLocationChange() {
        this.jobDescriptionForm.get('clientName').setValue(null);
        this.jobDescriptionForm.get('clientPhoneNo').setValue(null);
        this.jobDescriptionForm.get('clientEmail').setValue(null);
        this.loadAddress([]);
    }
    // Load job Desc form with values
    loadFormValues(response) {
        response = Object.assign(Object.assign({}, response), { isMiddleVendor: response.vendorList && response.vendorList.length > 0, startDate: response.startDate ? new Date(moment(response.startDate).format('MM/DD/YYYY')) : null, endDate: response.endDate ? new Date(moment(response.endDate).format('MM/DD/YYYY')) : null, duties: response.duties ? response.duties : [] });
        this.jobDescriptionForm.reset(Object.assign(Object.assign({}, response), { selectedRaiobtn: 0, jobRole: null }));
        this.loadDuties(response.duties);
        this.loadAddress(response.address);
        this.loadVendor(response.vendorList);
    }
    loadVendor(list) {
        this.jobDescriptionForm.controls['vendorList'].clear();
        if (list && list.length > 0) {
            list.forEach(element => {
                this.createVendorDetailsItem(element);
            });
        }
    }
    loadAddress(list) {
        this.jobDescriptionForm.controls['address'].clear();
        if (list && list.length > 0) {
            list.forEach(element => {
                this.createAddressItem(element);
            });
        }
        else {
            this.createAddressItem({ id: null });
        }
    }
    loadDuties(list) {
        this.jobDescriptionForm.controls['duties'].clear();
        list.forEach(element => {
            this.jobDescriptionForm.controls['duties'].push(this.buildDutyList(element));
        });
    }
    handleVendorChkboxChange(input) {
        if (input.checked) {
            this.createVendorDetailsItem({});
        }
        else {
            this.jobDescriptionForm.controls['vendorList'].clear();
        }
    }
    getCountries() {
        this.cacheCountyService.getCountry().pipe(takeUntil(this.observableSubscription$)).subscribe();
        this.cacheCountyService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            if (data.listCountries.length > 0) {
                this.countryList = data.listCountries;
            }
        });
    }
    getWageUnitType() {
        this.referenceLibraryService.getReferenceData('PAYTYP')
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.wageUnitType = response;
        });
    }
    handleDeleteAllDuties() {
        if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
            // api call to check whether ios is mapped or not
            const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
            deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response) {
                    // if duty has id and user tries to delete it
                    this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.jobDescriptionForm.value.id, 0)
                        .pipe(takeUntil(this.observableSubscription$))
                        .subscribe((IOSMappingResponse) => {
                        if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
                            this.handleReconfirmDuty();
                        }
                        else {
                            this.jobDescriptionForm.controls['duties'].clear();
                            this.store.dispatch(new MarkDirtyFormAction({
                                dirty: true
                            }));
                        }
                    });
                }
            });
        }
        else {
            this.jobDescriptionForm.controls['duties'].clear();
            this.store.dispatch(new MarkDirtyFormAction({
                dirty: true
            }));
        }
    }
    handleReconfirmDuty(dutyIndex = null) {
        const deleteReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, Object.assign(Object.assign({}, deleteDialogConfigurations), { data: {
                deleteMessage: 'Job duties cannot be deleted as Itinerary of Services mapping exists with the job duties. Do you want continue with the deletion of Itinerary of Services mapping?'
            } }));
        deleteReconfirmDialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.jobDescriptionForm.controls['jobDutyForceDelete'].setValue(true);
                if (dutyIndex) {
                    this.jobDescriptionForm.controls['duties'].removeAt(dutyIndex);
                }
                else {
                    this.jobDescriptionForm.controls['duties'].clear();
                }
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
        });
    }
    handleDutyDelete(input) {
        if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
            // api call to check whether ios is mapped or not
            const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
            deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response) {
                    if (input.duty['id']) {
                        // if duty has id and user tries to delete it
                        this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.jobDescriptionForm.value.id, this.jobDescriptionForm.value.duties[input.dutyIndex].id)
                            .pipe(takeUntil(this.observableSubscription$))
                            .subscribe((IOSMappingResponse) => {
                            if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
                                this.handleReconfirmDuty(input.dutyIndex);
                            }
                            else {
                                this.jobDescriptionForm.controls['duties'].removeAt(input.dutyIndex);
                                this.store.dispatch(new MarkDirtyFormAction({
                                    dirty: true
                                }));
                            }
                        });
                    }
                    else {
                        // direct delete after confirmation without IOS mapping check
                        this.jobDescriptionForm.controls['duties'].removeAt(input.dutyIndex);
                        this.store.dispatch(new MarkDirtyFormAction({
                            dirty: true
                        }));
                    }
                }
            });
        }
        else {
            this.jobDescriptionForm.controls['duties'].removeAt(input.dutyIndex);
            this.store.dispatch(new MarkDirtyFormAction({
                dirty: true
            }));
        }
    }
    handleSubDutyDelete(input) {
        if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
            // api call to check whether ios is mapped or not
            const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
            deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response) {
                    this.jobDescriptionForm.controls['duties']
                        .controls[input.dutyIndex]
                        .controls['subJobDuty'].removeAt(input.subJobDutyIndex);
                    this.store.dispatch(new MarkDirtyFormAction({
                        dirty: true
                    }));
                }
            });
        }
        else {
            this.jobDescriptionForm.controls['duties']
                .controls[input.dutyIndex]
                .controls['subJobDuty'].removeAt(input.subJobDutyIndex);
            this.store.dispatch(new MarkDirtyFormAction({
                dirty: true
            }));
        }
    }
    updateFormControls() {
        this.jobDescriptionForm.get('thisFulltime').valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe((value) => {
            if (value) {
                this.jobDescriptionForm.get('workingHoursPerWeek').clearValidators();
            }
            else {
                this.jobDescriptionForm.get('workingHoursPerWeek').setValidators(Validators.required);
            }
            this.jobDescriptionForm.get('workingHoursPerWeek').reset();
            this.jobDescriptionForm.get('workingHoursPerWeek').updateValueAndValidity();
        });
    }
    postJobDescription(val = []) {
        this.jobDescriptionForm.value.duties = val;
        const intermediateObj = Object.assign({}, this.jobDescriptionForm.value);
        intermediateObj.address.forEach((element) => {
            delete element['stateList'];
        });
        const _a = Object.assign(Object.assign({}, intermediateObj), { startDate: this.jobDescriptionForm.value.startDate ? moment(this.jobDescriptionForm.value.startDate).format('YYYY-MM-DD') : null, endDate: this.jobDescriptionForm.value.endDate ? moment(this.jobDescriptionForm.value.endDate).format('YYYY-MM-DD') : null, thisPastJob: false, selectedRaiobtn: intermediateObj.selectedRaiobtn, jobRole: intermediateObj.jobRole && intermediateObj.jobRole === 'Other' ? intermediateObj.otherJobPosition : intermediateObj.jobRole }), { selectedRaiobtn } = _a, payload = __rest(_a, ["selectedRaiobtn"]);
        const APIs = [
            this.apiService.postJobDescription(payload, this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
        ];
        // if (selectedRaiobtn === 1) {
        //   const selectJobRole = JSON.parse(sessionStorage.getItem('selectedJobRole'));
        //   const jobDuty = this.jobDescriptionForm.value.duties;
        // const jobDuty = this.jobDescriptionForm.value.duties ? this.jobDescriptionForm.value.duties.map(x => {
        //     return {
        //       dutyId: x.id ? x.id : 0,
        //       duty: x.name,
        //       subduty: x.subJobDuty && x.subJobDuty.length > 0 ?
        //         x.subJobDuty.map(y => {
        //           return {
        //             dutyId: y.id ? y.id : 0,
        //             duty: y.name,
        //           };
        //         }) : []
        //     };
        //   }) : [];
        // const jobRole = {
        //   id: selectJobRole.id,
        //   jobDuty,
        //   jobRoleName: selectJobRole.jobTitle === 'Other' ? this.jobDescriptionForm.value.otherJobPosition : selectJobRole.jobTitle,
        //   requestFlag: 'updatemasterdata'
        // };
        // APIs.push(this.apiService.saveJobRole(this.inputData.companyId,
        //   this.jobDescriptionForm.value.selectedCategory.id, jobRole));
        // }
        combineLatest(APIs)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            // this.saveMasterDataDuty();
            if (response[0] && response[0].status === 200) {
                this.toastr.success(response[0].message, 'Success');
                if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
                    this.updateStepStatus('INPROGRESS');
                }
                else {
                    this.getJobDescription();
                }
            }
            if (selectedRaiobtn === 1 && response[1] && response[1].status === 200) {
                this.toastr.success(response[1]['message'], 'Success');
            }
        });
    }
    getSocCode() {
        this.titleSoc = '';
        this.apiService.ongetSOCCode(this.jobDescriptionForm.value.socCode)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(data => {
            if (data === null) {
                this.titleSoc = 'No SOC occupation title found';
                this.jobDescriptionForm.patchValue({
                    socTitle: null,
                });
            }
            else {
                // this.socTitle = data.title;
                this.titleSoc = '';
                this.jobDescriptionForm.patchValue({
                    socTitle: data.title,
                });
            }
        });
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    // Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // console.log('toggleControlsStatus ::', this.disabledControls);
        this.fileUploadConfigurations = Object.assign({}, {
            disableControls: this.disabledControls,
            isDocumentTypeRequired: true,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/`,
            postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/fileCategory/`,
            deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
            documentTypeDropdownCode: (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR',
            getDocTypeApiUrl: '/referenceLibrary/POSOFFRLTR'
            // getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/`,
            // postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/fileCategory/`,
            // deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
            // documentTypeDropdownCode: this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'OFFLTR'
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    handleCancel() {
        this.getJobDescription();
    }
    handleAddLocationClick() {
        this.createAddressItem({ id: 0 });
    }
    handleDeleteWorkLocation(input, index) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
        deleteDialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                if (input.value && input.value.workLocationId) {
                    this.apiService.deleteWorkLocation(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, input.value.workLocationId)
                        .pipe(takeUntil(this.observableSubscription$))
                        .subscribe((response) => {
                        if (response) {
                            this.toastr.success(response.message, 'Success');
                            this.jobDescriptionForm.controls['address'].removeAt(index);
                            if (this.jobDescriptionForm.controls['address'].length <= 0) {
                                this.handleAddLocationClick();
                            }
                        }
                    });
                }
                else {
                    this.jobDescriptionForm.controls['address'].removeAt(index);
                    this.toastr.success('Deleted Successfully', 'Success');
                    if (this.jobDescriptionForm.controls['address'].length <= 0) {
                        this.handleAddLocationClick();
                    }
                }
            }
        });
    }
    onWageUnitChange(event) {
        switch (event.value) {
            case 'HOUR':
                this.jobDescriptionForm.controls['wagesPerYear'].setValue(2080 * this.jobDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'WEEK':
                this.jobDescriptionForm.controls['wagesPerYear'].setValue(52 * this.jobDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'BIWEEK':
                this.jobDescriptionForm.controls['wagesPerYear'].setValue(26 * this.jobDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'MONTH':
                this.jobDescriptionForm.controls['wagesPerYear'].setValue(12 * this.jobDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'YEAR':
                this.jobDescriptionForm.controls['wagesPerYear'].setValue(this.jobDescriptionForm.controls['wagesFrom'].value);
                break;
        }
    }
    onDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
BaseJobDescriptionLibraryService.ɵfac = function BaseJobDescriptionLibraryService_Factory(t) { return new (t || BaseJobDescriptionLibraryService)(i0.ɵɵinject(i1$1.FormBuilder), i0.ɵɵinject(i2.Store), i0.ɵɵinject(APIJobDescription), i0.ɵɵinject(i4.ToastrService), i0.ɵɵinject(i5.StepStatusUpdatePayloadService), i0.ɵɵinject(i6.DirtyFormGuard), i0.ɵɵinject(i7.CacheCountryListService), i0.ɵɵinject(i8.ReferenceLibraryService), i0.ɵɵinject(i0.ChangeDetectorRef), i0.ɵɵinject(i9.DialogService), i0.ɵɵinject(DateValidators), i0.ɵɵinject(i10.AppServicesLibraryService)); };
BaseJobDescriptionLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseJobDescriptionLibraryService, factory: BaseJobDescriptionLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseJobDescriptionLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.Store }, { type: APIJobDescription }, { type: i4.ToastrService }, { type: i5.StepStatusUpdatePayloadService }, { type: i6.DirtyFormGuard }, { type: i7.CacheCountryListService }, { type: i8.ReferenceLibraryService }, { type: i0.ChangeDetectorRef }, { type: i9.DialogService }, { type: DateValidators }, { type: i10.AppServicesLibraryService }]; }, null); })();
class DateValidators {
    dateLessThan(dateField1, dateField2) {
        return (formGroup) => {
            const date1 = formGroup.get(dateField1).value;
            const date2 = formGroup.get(dateField2).value;
            if ((date1 !== null && date2 !== null) && date1 > date2) {
                formGroup.get(dateField2).setErrors({ positionDateValidation: true });
            }
            else {
                formGroup.get(dateField2).setErrors(null);
            }
        };
    }
}
DateValidators.ɵfac = function DateValidators_Factory(t) { return new (t || DateValidators)(); };
DateValidators.ɵprov = i0.ɵɵdefineInjectable({ token: DateValidators, factory: DateValidators.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateValidators, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

/*
 * Public API Surface of base-job-description-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIJobDescription, BaseJobDescriptionLibraryService, DateValidators, deleteDialogConfigurations };
//# sourceMappingURL=base-job-description-library.js.map
